import { useEffect, useMemo } from 'react';
import { debounce } from '@thd-olt-functional/utils';

const useFilterPanelSticky = ({ stickyNavRef, desktopStickyFilterPanelRef, direction }) => {
  // Memoized so the debounced function (and its internal timer state) persists across renders —
  // only recreated when direction actually changes, since the handler's closure reads it.
  const scrollHandler = useMemo(() => debounce(20, () => {
    if (stickyNavRef?.current) {
      const stickyNavParentNode = stickyNavRef?.current?.parentNode;
      const FilterPanelNode = desktopStickyFilterPanelRef?.current;

      const stickyNavParentHeight = stickyNavParentNode?.clientHeight;
      const FilterPanelTop = FilterPanelNode.getBoundingClientRect()?.top;
      const additionalTreshold = 10;

      /* accounts for both header floaters on the site when going up, both matchup with height */
      const stickyNavOffsetPadding =
        direction === 'up' ? stickyNavParentHeight * 2 : stickyNavParentHeight;
      const filterPanelExtraPadding = FilterPanelTop - stickyNavOffsetPadding - additionalTreshold;
      const absFilterPanelExtraPadding = Math.abs(filterPanelExtraPadding);

      if (filterPanelExtraPadding < 0) {
        FilterPanelNode.style.paddingTop = `${absFilterPanelExtraPadding}px`;
      }
      if (filterPanelExtraPadding >= 0) {
        FilterPanelNode.style.paddingTop = '0px';
      }
      if (FilterPanelTop < 0) {
        FilterPanelNode.style.paddingTop = `${stickyNavOffsetPadding}px`;
      }
    }
  }), [stickyNavRef, desktopStickyFilterPanelRef, direction]);

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler, { passive: true });

    return () => window.removeEventListener('scroll', scrollHandler);
  }, [scrollHandler]);
};

export default useFilterPanelSticky;
